// Mock data for Carz Street Premium Car Service

export const services = [
  {
    id: 1,
    title: "Regular Service",
    description: "Comprehensive maintenance for optimal performance",
    icon: "wrench",
    features: ["Oil Change", "Filter Replacement", "Fluid Top-up", "Safety Inspection"]
  },
  {
    id: 2,
    title: "Car Spa & Detailing",
    description: "Premium cleaning and restoration services",
    icon: "sparkles",
    features: ["Interior Detailing", "Exterior Polish", "Ceramic Coating", "Paint Protection"]
  },
  {
    id: 3,
    title: "Denting & Painting",
    description: "Expert body work and paint restoration",
    icon: "paintbrush",
    features: ["Dent Removal", "Scratch Repair", "Full Body Paint", "Color Matching"]
  },
  {
    id: 4,
    title: "AC Repair",
    description: "Climate control system diagnostics and repair",
    icon: "wind",
    features: ["Gas Refilling", "Compressor Repair", "Duct Cleaning", "Temperature Check"]
  },
  {
    id: 5,
    title: "Accident Repair",
    description: "Complete collision repair and restoration",
    icon: "shield",
    features: ["Frame Straightening", "Panel Replacement", "Structural Repair", "Safety Check"]
  },
  {
    id: 6,
    title: "Insurance Claims",
    description: "Hassle-free insurance processing assistance",
    icon: "fileText",
    features: ["Claim Processing", "Documentation", "Direct Billing", "Quick Approval"]
  },
  {
    id: 7,
    title: "24/7 Roadside Assistance",
    description: "CSA support round the clock, wherever you are",
    icon: "truck",
    features: ["Battery Issues", "Towing with Crane", "Tyre Puncture", "Fuel Delivery"]
  },
  {
    id: 8,
    title: "Car Modification & Customization",
    description: "Personalize your ride with expert modifications and premium upgrades",
    icon: "zap",
    features: [
      "Performance Upgrades (ECU, Exhaust, Air Intake)",
      "Custom Body Kits & Spoilers",
      "Interior Customization (Seats, Trim, Ambient Lighting)",
      "Aesthetic Mods (Wraps, Alloys, Tinting)"
    ]
  }
];

export const googleRating = { score: "4.7", count: "511" };

export const testimonials = [
  {
    id: 1,
    name: "Bhautik Dave",
    role: "Local Guide · 16 reviews",
    timeAgo: "4 years ago",
    content: "The best thing about this place is everything is under one roof — whether it's car detailing, spa, car service or any car solution. This place caters to all types of cars, from high-end to base models.",
    rating: 5
  },
  {
    id: 2,
    name: "Chinmay Upadhyay",
    role: "Local Guide · 18 reviews",
    timeAgo: "2 years ago",
    content: "The best workshop for car service, car spa, car repairing & everything about the car. Vinod bhai, the owner of Carz Street, and all the staff are good in nature. I recommend everyone to visit this workshop.",
    rating: 5
  },
  {
    id: 3,
    name: "Dr. Zach McLaren",
    role: "Local Guide · 14 reviews",
    timeAgo: "5 years ago",
    content: "The only place in Ahmedabad that has exceptional car spa and detailing. Great customer service experience. Giving 5 stars for the same. Cheers guys, keep up your good work!",
    rating: 5
  },
  {
    id: 4,
    name: "Bhavin Acharya",
    role: "5 reviews",
    timeAgo: "4 years ago",
    content: "Under one roof you get all services related to car spa. This is my fifth year and I am happy to say they have always improved services in a better way. The owner himself is very polite with a smiling face. Must visit!",
    rating: 5
  },
  {
    id: 5,
    name: "BireN RaO (Raja)",
    role: "Local Guide · 20 reviews",
    timeAgo: "3 years ago",
    content: "I went for Ceramic Coating on my newly bought Škoda Slavia. The results were amazingly awesome. Best price, best service & 100 percent customer satisfaction!",
    rating: 5
  },
  {
    id: 6,
    name: "Priyam Vora",
    role: "Local Guide · 12 reviews",
    timeAgo: "4 years ago",
    content: "Got ceramic coating of my new Kia Sonet. Amazing work!!!",
    rating: 5
  },
  {
    id: 7,
    name: "Pushpraj Yadu",
    role: "2 reviews",
    timeAgo: "2 years ago",
    content: "I was hesitant at first, but Carz Street proved me wrong. The ceramic coating service in Ahmedabad has transformed my car. It's like a shield against everyday wear and tear.",
    rating: 5
  },
  {
    id: 8,
    name: "Jay Vadnagara",
    role: "11 reviews",
    timeAgo: "2 years ago",
    content: "Visited Carz Street in Ahmedabad and I must say they did a fantastic job. My car looks brand new! The staff was friendly and the service was very nice. Highly recommended!",
    rating: 4
  },
  {
    id: 9,
    name: "Hardik Solanki",
    role: "3 reviews",
    timeAgo: "3 years ago",
    content: "Good service and No.1 ceramic coating center in Ahmedabad.",
    rating: 5
  },
  {
    id: 10,
    name: "Rajesh Khatri",
    role: "Local Guide · 29 reviews",
    timeAgo: "4 years ago",
    content: "Car ceramic coating — the best place for car spa. Professional staff and excellent work.",
    rating: 5
  }
];

export const amcPlan = {
  name: "Comprehensive Maintenance Programme",
  forModels: "Small / Hatchback / Sedan",
  duration: "1.5 Years or 10,000 Kms",
  durationNote: "(whichever comes first)",
  actualValue: "33,000",
  specialPrice: "18,999",
  priceNote: "(incl. tax)",
  contact: "8980003797",
  benefits: [
    { benefit: "Periodic Maintenance Service with Engine Oil, Oil Filter & Drain Washer + Air & AC Filter (incl. 1 Paid Service)", frequency: "2 + 1 Times", value: "12,400" },
    { benefit: "HDS Scanning (Computerised Diagnostics)", frequency: "3 Times", value: "2,400" },
    { benefit: "Wheel Alignment & Balancing", frequency: "2 Times", value: "2,800" },
    { benefit: "AC Service (with AC Compressor Oil & Gas)", frequency: "1 Time", value: "4,500" },
    { benefit: "Engine Cooling System Service (Radiator Flushing)", frequency: "1 Time", value: "2,500" },
    { benefit: "Rubbing & Polishing", frequency: "2 Times", value: "4,000" },
    { benefit: "Interior Cleaning", frequency: "2 Times", value: "4,400" }
  ],
  offers: [
    "Breakdown Charges FREE within city limits (Per Visit Charge ₹500 outside)",
    "50% Labour Charges FREE (excluding outside repairing work)",
    "Personalized Service — Free Pick up & Drop (only for service)",
    "No Additional Labour Charge for any General Repair work",
    "No Breakdown Charge within city limits"
  ],
  terms: [
    "Covers all Periodic Maintenance for 1.5 Years or 10,000 Kms (whichever comes first).",
    "All parts chargeable — excluding 2 times Engine Oil, Oil Filter, Air Filter, AC Filter & Drain Washer.",
    "Body & Paint / Accident jobs are not included in this programme."
  ]
};

export const founderStory = {
  name: "Mr. Vinod Parmar",
  role: "Founder & Managing Director – Carz Street",
  photo: "/founder-vinod-parmar.jpeg",
  intro: "With over 30 years of experience in the Indian automotive industry, Mr. Vinod Parmar has dedicated his career to delivering excellence in vehicle service, technical expertise, and customer satisfaction. His journey reflects continuous growth—from a skilled technician to a respected automotive leader and successful entrepreneur.",
  paragraphs: [
    "Mr. Parmar began his career in 1996 as a Technician at Tata Cargo Motors Pvt. Ltd., Rajpath Club, Ahmedabad, where he built a strong technical foundation. Through his commitment and expertise, he steadily progressed into leadership roles with some of India's most renowned automobile brands.",
    "After gaining decades of technical, operational, and management experience with leading automotive brands, Mr. Parmar decided to pursue his entrepreneurial vision. In 2018, he established his first independent multi-brand workshop, Family Garage, near Zydus Hospital, Thaltej, Ahmedabad. The workshop quickly earned a reputation for quality workmanship, transparency, and customer trust.",
    "Building on this success, he founded Carz Street in 2021, with its Head Office located at Sindhu Bhavan, Ahmedabad, Gujarat. Guided by his vision of making premium-quality car service accessible to everyone, Carz Street was created to offer dealership-level expertise at fair and transparent prices.",
    "In May 2026, Carz Street expanded its presence with a new branch in Indore, Madhya Pradesh, marking another important milestone in the company's growth journey. The next chapter is already underway, with a new branch coming soon at Vaishnodevi Circle, Ahmedabad."
  ],
  timeline: [
    { period: "1996 – 2002", role: "Technician", company: "Tata Cargo Motors Pvt. Ltd." },
    { period: "2002 – 2006", role: "Senior Technician & Floor Manager", company: "Aspi Motors (Authorized Tata Dealer)" },
    { period: "2006 – 2008", role: "Diagnosis Expert cum Trainer (DET) – PAN India", company: "Bacha Motors Tata Dealers" },
    { period: "2008 – 2013", role: "Workshop Manager Trainer", company: "Landmark Honda" },
    { period: "2013 – 2015", role: "Quality Inspector", company: "Infinium Toyota" },
    { period: "2015 – 2018", role: "Group General Manager – PAN India", company: "Concept Hyundai" },
    { period: "2018", role: "Founder – Family Garage", company: "First independent multi-brand workshop, Thaltej" },
    { period: "2021", role: "Founder & MD – Carz Street", company: "Head Office, Sindhu Bhavan, Ahmedabad" }
  ],
  vision: "To provide dealership-quality service without the high dealership cost. Many vehicle owners pay significantly higher service charges at authorized dealerships, even for routine maintenance. Carz Street bridges this gap by delivering the same level of technical expertise, genuine care, and professional standards—at a more affordable price.",
  message: "Our mission has always been to provide every customer with dealership-quality service, honest advice, and complete transparency at a fair price. At Carz Street, every vehicle is treated with the same care and precision as if it were our own. Customer trust is not just our goal—it is the foundation of our business."
};

export const founderAwards = [
  "Best Technician – Tata Motors Cargo (PAN India Level)",
  "Best DET in India Award – Tata Motors (PAN India Level)",
  "Best Trainer Award – Honda (PAN India)",
  "Best General Manager – Hyundai (PAN India)",
  "Best Customer Satisfaction Award – West Zone Hyundai",
  "Best Customer Retention Activity Award",
  "Best Staff Retention Activity Award",
  "Best Car Service Dealer Award – Carz Street, Ahmedabad",
  "Best Car Care Excellence Service Award – Carz Street, MY FM Ahmedabad"
];

export const insurancePartners = [
  "Zuno General Insurance Limited",
  "HDFC ERGO Car Insurance",
  "IndusInd General Insurance",
  "The Oriental Insurance Company",
  "The New India Assurance Company Limited",
  "Shriram General Insurance",
  "SBI General Insurance",
  "TATA AIG General Insurance",
  "Bajaj General Insurance Limited",
  "Zurich Kotak General Insurance",
  "ICICI Lombard General Insurance Company Limited",
  "United India Insurance Company Limited",
  "Go Digit General Insurance",
  "National Insurance Company",
  "Cholamandalam MS General Insurance"
];

export const awards = [
  {
    id: 1,
    image: "/award-1.jpeg",
    title: "MY FM Excellence Award 2026",
    description: "Recognized for excellence in automotive service at the MY FM Excellence Awards."
  },
  {
    id: 2,
    image: "/award-2.jpeg",
    title: "Building Gujarat - Elite Edition",
    description: "Honoured at the Building Gujarat Elite Edition for outstanding contribution to the industry."
  },
  {
    id: 3,
    image: "/award-3.jpeg",
    title: "Industry Recognition",
    description: "Felicitated for technical expertise and commitment to customer satisfaction."
  }
];

export const galleryImages = [
  {
    src: "/gallery-car-1.jpeg",
    title: "Reception & Brand Wall",
    caption: "Our welcoming reception, showcasing the premium multi-brand car service badges we work on every day."
  },
  {
    src: "/gallery-car-2.jpeg",
    title: "Modern Service Bays",
    caption: "State-of-the-art workshop bays equipped with computerised diagnostics for periodic service, AC repair and denting-painting."
  },
  {
    src: "/gallery-car-3.jpeg",
    title: "Awards & Recognition Shelf",
    caption: "A dedicated display of trophies, certifications and customer-satisfaction awards earned over 26+ years."
  },
  {
    src: "https://images.unsplash.com/photo-1609521233053-345bfa8b6f17?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwY2FyJTIwc2VydmljZXxlbnwwfHx8fDE3ODQ5Njg3OTB8MA&ixlib=rb-4.1.0&q=85",
    title: "Ceramic Coating & Detailing",
    caption: "Precision paint correction and ceramic coating give your car a mirror-finish protection that lasts for years."
  },
  {
    src: "https://images.unsplash.com/photo-1694026006855-6f4f0cdee8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwY2FyJTIwc2VydmljZXxlbnwwfHx8fDE3ODQ5Njg3OTB8MA&ixlib=rb-4.1.0&q=85",
    title: "Interior Detailing",
    caption: "Deep-cleaning and reconditioning of upholstery, dashboard and trim — inside restored to showroom fresh."
  },
  {
    src: "https://images.unsplash.com/photo-1618642542397-ef97a739f1d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwY2FyJTIwc2VydmljZXxlbnwwfHx8fDE3ODQ5Njg3OTB8MA&ixlib=rb-4.1.0&q=85",
    title: "Premium Car Servicing",
    caption: "Multi-point inspection and periodic maintenance handled by factory-trained technicians for luxury and everyday cars alike."
  },
  {
    src: "https://images.unsplash.com/photo-1618642624018-a370cbf3cd80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjYXIlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODQ5Njg3OTB8MA&ixlib=rb-4.1.0&q=85",
    title: "Luxury Car Workshop",
    caption: "Dealership-grade workshop environment — from sedans and hatchbacks to SUVs and luxury European brands."
  },
  {
    src: "https://images.unsplash.com/photo-1673166105764-a6aa7e0e73a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjYXIlMjB3b3Jrc2hvcHxlbnwwfHx8fDE3ODQ5Njg3OTB8MA&ixlib=rb-4.1.0&q=85",
    title: "Wheel Alignment & Balancing",
    caption: "Precision wheel alignment and computerised balancing for a smoother ride, longer tyre life and better fuel efficiency."
  },
  {
    src: "https://images.pexels.com/photos/4756887/pexels-photo-4756887.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    title: "Engine & Mechanical Work",
    caption: "Comprehensive engine diagnostics, cooling-system flushing and mechanical repairs done with genuine OEM-grade parts."
  }
];

export const aboutImages = [
  "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwxfHxjYXIlMjBtZWNoYW5pYyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODQ5Njg3OTV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1504222490345-c075b6008014?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHw0fHxjYXIlMjBtZWNoYW5pYyUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3ODQ5Njg3OTV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/8986105/pexels-photo-8986105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
];

export const stats = [
  { number: "26+", label: "Years Experience" },
  { number: "2L+", label: "Cars Serviced" },
  { number: "98%", label: "Client Satisfaction" },
  { number: "24/7", label: "Support Available" }
];

export const brands = [
  "Mercedes-Benz", "BMW", "Audi", "Jaguar", "Land Rover",
  "Porsche", "Volvo", "Lexus", "Tesla", "Bentley"
];

// Mock API functions
export const submitContactForm = async (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Contact form submitted:', formData);
      resolve({ success: true, message: 'Thank you! We will contact you soon.' });
    }, 1000);
  });
};

export const submitBookingForm = async (bookingData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Booking submitted:', bookingData);
      resolve({ success: true, message: 'Booking confirmed! We will call you to confirm the appointment.' });
    }, 1000);
  });
};

export const submitQuoteRequest = async (quoteData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Quote request submitted:', quoteData);
      resolve({ success: true, message: 'Quote request received! We will send you a detailed quote within 24 hours.' });
    }, 1000);
  });
};